import { render, staticRenderFns } from "./mixcheck.vue?vue&type=template&id=2a2fd4b4&scoped=true"
import script from "./mixcheck.vue?vue&type=script&lang=js"
export * from "./mixcheck.vue?vue&type=script&lang=js"
import style0 from "./mixcheck.vue?vue&type=style&index=0&id=2a2fd4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2fd4b4",
  null
  
)

export default component.exports